import React from 'react';

import CustomTd from '../shared/table/CustomTd';
import formatter from '../../utilities/formatter'

const MonthlyBusinessItem = ({ item }) => {
    return (
        <tr>
            <CustomTd>
                {formatter.date(item.dateCreated)}
            </CustomTd>
            <CustomTd>
                {item.customerName}
            </CustomTd>
            <CustomTd>
                {item.designer}
            </CustomTd>
            <CustomTd>
                {formatter.date(item.installDate)}
            </CustomTd>
            <CustomTd>
                {formatter.currency(item.jobTotal)}
            </CustomTd>
            <CustomTd>
                {formatter.currency(item.deposit)}
            </CustomTd>
            <CustomTd>
                {item.depositType && item.depositType === '0' ? '' : item.depositType.replace('_', ' ')}
            </CustomTd>
            <CustomTd>
                {formatter.date(item.dateDeposit)}
            </CustomTd>
            <CustomTd>
                {formatter.currency(item.balanceDue)}
            </CustomTd>
            <CustomTd>
                {item.paidInFull ? '✓' : ''}
            </CustomTd>
            <CustomTd>
                {formatter.date(item.dateBalancePaid)}
            </CustomTd>
            <CustomTd>
                {item.leadSource}
            </CustomTd>
            <CustomTd colSpan={2}>
                {item.subLeadSource}
            </CustomTd>
        </tr>
    );
}

export default MonthlyBusinessItem;